import { icons } from './icons'

export interface ToastOptions {
  undoMs?: number
  onUndo?: () => void
}

/** Confirmation toast; when onUndo is given, shows a 5s undo with a countdown bar. */
export function showToast(root: ShadowRoot, reportId: string, opts: ToastOptions = {}): void {
  root.querySelector('.qc-toast')?.remove()
  const toast = document.createElement('div')
  toast.className = 'qc-toast'
  toast.setAttribute('role', 'status')
  const short = reportId.slice(0, 8)
  toast.innerHTML = `
    <span class="qc-toast-ic">${icons.check}</span>
    <span>Report filed</span>
    <span class="qc-toast-id">#${short}</span>
    ${opts.onUndo ? '<button data-ref="undo">Undo</button>' : ''}
    <button data-ref="copy">Copy ID</button>
    ${opts.undoMs ? '<span class="qc-undobar"></span>' : ''}
  `
  toast.querySelector('[data-ref="copy"]')!.addEventListener('click', () => {
    navigator.clipboard?.writeText(reportId).catch(() => {})
  })
  const undoBtn = toast.querySelector('[data-ref="undo"]') as HTMLButtonElement | null
  let done = false
  const dismiss = () => {
    if (done) return
    done = true
    toast.remove()
  }
  if (undoBtn && opts.onUndo) {
    undoBtn.addEventListener('click', () => {
      dismiss()
      opts.onUndo!()
    })
  }
  root.appendChild(toast)
  setTimeout(dismiss, opts.undoMs ?? 4000)
}
